export default "__VITE_ASSET__DD4YRd3S__"